import { render } from "./ManageHomePage.vue?vue&type=template&id=6ddf42c0"
import script from "./ManageHomePage.vue?vue&type=script&lang=ts"
export * from "./ManageHomePage.vue?vue&type=script&lang=ts"
script.render = render

export default script